// src/config.js

// A URL base do seu backend. Usada para construir URLs completas, como a do avatar.
export const API_BASE_URL = 'http://localhost:4001';